import { instance } from '../../config/intercepter';

export const getRfCodeFn = async () => {
  const response = await instance.get(`api/getrfcode`);
  return response.data;
};

export const onlinePaymentInititFn = async (payload) => {
  const response = await instance.post(`api/onlinepayments/initiate`,payload);
  return response.data;
};

export const redeemPaymentInitFn = async (payload) => {
  const response = await instance.post(`api/loyalty/redemption`,payload);
  return response.data;
};

export const onlinePaymentSuccessFn = async () => {
  const response = await instance.get(`api/onlinepayments/success`);
  return response.data;
};

export const onlinePaymentFailureFn = async () => {
  const response = await instance.get(`api/onlinepayments/failure`);
  return response.data;
};
